'use client';

import {
	For, Steps, useSteps,
	Button,
	ButtonGroup,
	Card,
} from '@chakra-ui/react';

import { RegistrationComplete } from '@/modules/authentication/presentation/components';
import { useRegistrationSteps } from '@/modules/authentication/view-model';

import { Form } from '@packages/hook-form-wrapper';

export const RegistrationStepContainer = () => {
	const { registrationSteps } = useRegistrationSteps();
	const steps = useSteps({ count: registrationSteps.length, defaultStep: 0 });

	const handleNext = async (submit: () => Promise<string | void>) => {
		try {
			await submit();
			steps.goToNextStep();
		}
		catch (err) {
			console.error(err);
		}
	};

	return (
		<Steps.RootProvider value={steps}>
			<For each={registrationSteps}>
				{(step, index) => (
					<Steps.Content index={index} key={step.title}>
						<Form.Provider
							defaultValues={step.defaultValues}
							onSubmit={data => handleNext(async () => step.formSubmit(data as never))}
							schema={step.schema}
						>
							<Card.Root>
								<Card.Header>
									<Card.Title textAlign="center" textStyle="h3">
										{step.title}
									</Card.Title>
								</Card.Header>
								<Card.Body
									maxH="70vh"
									overflow="scroll"
									px="md"
									py="lg"
									scrollbar="hidden"
								>
									{step.component && <step.component />}
								</Card.Body>
								<Card.Footer as={ButtonGroup} justifyContent="space-between">
									<Button disabled={!steps.hasPrevStep} onClick={steps.goToPrevStep} variant="outline">
										Prev
									</Button>
									<Form.SubmitButton>
										Next
									</Form.SubmitButton>
								</Card.Footer>
							</Card.Root>
						</Form.Provider>
					</Steps.Content>
				)}
			</For>
			<Steps.CompletedContent>
				<RegistrationComplete />
			</Steps.CompletedContent>
		</Steps.RootProvider>
	);
};
